// FleetViewToggle.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LuCircleEqual, LuStopCircle } from 'react-icons/lu';
import { useFleetView } from '../contexts/FleetViewContext';

// Switch da "Visão expandida" da tela Minha Frota (issue #557) — mesmo
// visual/estrutura de ThemeToggle.jsx e ExpandToggle.jsx (pill + bolinha
// que desliza), pra ficar igual aos outros dois ao lado dele no header em
// vez do switch padrão do Bootstrap. Ícones (Lucide, react-icons/lu):
// LuCircleEqual à esquerda — desligado, mapa padrão + grid embaixo,
// "diminuir" — e LuStopCircle à direita — ligado, mapa grande tipo tela
// cheia, "aumentar". Pedido era LuCircleStop, mas essa versão do
// react-icons (4.12.0) não tem esse nome — é do Lucide mais recente;
// LuStopCircle é o mesmo ícone (círculo com quadrado dentro) com o nome
// que existe aqui.
const FleetViewToggle = ({ className = '', size = 'md' }) => {
  const { t } = useTranslation();
  const { expandedView, toggleExpandedView } = useFleetView();

  const sizeStyles = {
    sm: { width: '2.5rem', height: '1.25rem', circle: '1rem', icon: '0.55rem' },
    md: { width: '3rem', height: '1.5rem', circle: '1.25rem', icon: '0.75rem' },
    lg: { width: '3.5rem', height: '1.8rem', circle: '1.5rem', icon: '1rem' },
    xl: { width: '4.1rem', height: '2.1rem', circle: '1.75rem', icon: '1.1rem' },
  };

  const currentSize = sizeStyles[size] || sizeStyles.md;

  return (
    <button
      onClick={toggleExpandedView}
      className={className}
      style={{
        marginTop: 0,
        width: currentSize.width,
        height: currentSize.height,
        borderRadius: '9999px',
        backgroundColor: expandedView ? '#202727' : '#FFFFFF',
        border: '1px solid var(--border-secondary)',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
      }}
      aria-label={t("HOME.EXPANDED_VIEW")}
      title={t("HOME.EXPANDED_VIEW")}
    >
      {/* Ícone de círculo com "=" (lado esquerdo) — visão padrão */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '8px',
          transform: 'translateY(-50%)',
          fontSize: currentSize.icon,
          color: expandedView ? '#fff' : '#000000',
          transition: 'all 0.3s ease',
        }}
      >
        <LuCircleEqual />
      </span>

      {/* Ícone de círculo com quadrado dentro (lado direito) — visão expandida */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          right: '8px',
          transform: 'translateY(-50%)',
          fontSize: currentSize.icon,
          color: expandedView ? '#fff' : '#000',
          transition: 'all 0.3s ease',
        }}
      >
        <LuStopCircle />
      </span>

      {/* Bola que se move */}
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: expandedView
            ? `calc(100% - ${currentSize.circle} - 2px)`
            : '2px',
          transform: 'translateY(-50%)',
          width: currentSize.circle,
          height: currentSize.circle,
          borderRadius: '50%',
          backgroundColor: !expandedView ? '#000000' : '#FFFFFF',
          transition: 'all 0.3s ease',
        }}
      ></span>
    </button>
  );
};

export default FleetViewToggle;
